import Dropzone, { DropzoneOptions } from 'react-dropzone'

import { Box, Button } from '@factorialco/deprecated-design-system'
import {
  DeleteWorkspaceLogoDocument,
  FactorialOneLayoutDocument,
  GetCurrentDocument,
  UploadWorkspaceLogoDocument,
} from 'generated/resources/graphql'

// nosemgrep do_not_use_panes
import PanesHeader from 'modules/core/components/PanesHeader'
// nosemgrep do_not_use_panes
import PanesPadForm from 'modules/core/components/PanesPadForm'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { InContextDemo } from './InContextDemo'

export const WorkspaceLogoUploadPane = () => {
  const { company } = useCurrentSession()
  const [uploadWorkspaceLogo, { loading: isUploading }] = useMutation(UploadWorkspaceLogoDocument, {
    extractorFn: (data) => data.companiesMutations.uploadWorkspaceLogoCompaniesLogo,
    refetchQueries: [GetCurrentDocument, FactorialOneLayoutDocument],
    awaitRefetchQueries: true,
  })
  const [deleteWorkspaceLogo, { loading: isDeleting }] = useMutation(DeleteWorkspaceLogoDocument, {
    extractorFn: (data) => data.companiesMutations.deleteWorkspaceLogoCompaniesLogo,
    refetchQueries: [GetCurrentDocument, FactorialOneLayoutDocument],
    awaitRefetchQueries: true,
  })

  const onDrop: DropzoneOptions['onDrop'] = ([file]: File[]) => {
    if (file) {
      uploadWorkspaceLogo({ variables: { companyId: company.id, file } })
    }
  }

  return (
    <PanesPadForm direction="horizontal">
      <div data-intercom-target="settings-workspace-logo-upload-pane">
        <PanesHeader
          title={i18n.t('appearance.workspace_logo.title')}
          illustration="brush-pencil"
          description={[
            i18n.t('appearance.workspace_logo.description'),
            i18n.t('appearance.workspace_logo.details'),
          ]}
        />
        <Box flexDirection="row" gap="s8">
          <Dropzone onDrop={onDrop} accept={{ 'image/*': [] }} multiple={false}>
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <Button type="secondary" loading={isUploading}>
                  {i18n.t('common.upload')}
                </Button>
              </div>
            )}
          </Dropzone>
          {company.workspaceLogo && (
            <Button
              type="negative"
              onClick={() => {
                deleteWorkspaceLogo({ variables: { companyId: company.id } })
              }}
              loading={isDeleting}
            >
              {i18n.t('common.remove')}
            </Button>
          )}
        </Box>
      </div>
      <div>
        <InContextDemo
          loading={isUploading || isDeleting}
          companyName={company.name}
          logoUrl={buildUrl(company.workspaceLogo)}
        />
      </div>
    </PanesPadForm>
  )
}
